import Swiper from "swiper";
import SwiperCore, {Navigation, Pagination, Thumbs} from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Thumbs]);
export default class ContactMap {
    constructor()
    {
        this.map = document.querySelector('#contact-map');
        this.wrapper = document.getElementById('contact-map');
        this.brand_lat = 53.8563564;
        this.brand_lng = 18.1329874;
        this.zoom = 8;
        this.images = '../wp-content/themes/skoda/resources/images/';
        this.type = 'all';
        this.slides = new Array();
        this.location = [];
        this.slider = false;
    }

    init()
    {
        if (!this.map) {
            return false;
        }
        this.sliderLocation();
        this.getDataFromApi();

        const scrollTo = (element) => {
            const y = element.getBoundingClientRect().top + window.scrollY - 200;
            window.scroll({
                top: y,
                behavior: 'smooth',
            });
        }

        document.querySelectorAll('.map-info-box').forEach((btn) => {
            btn.addEventListener('click', () => {
                this.showMap('custom-location', btn.getAttribute('data-address'));
                btn.style.background = 'white';
                if (window.innerWidth < 768) {
                    scrollTo(this.wrapper);
                }
            });
        });


    }

    sliderLocation()
    {

        this.slider = new Swiper('.js-map-slider', {
            direction: 'vertical',
            effect: 'slide',
            slidesPerView: 3,
            spaceBetween: 16,
            autoHeight: true,
            navigation: {
                nextEl: ".map-next",
                prevEl: ".map-prev",
            },
            breakpoints: {
                480: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 5,
                },
            },
        });
    }


    getDataFromApi()
    {
        const api_url =
        "/wp-json/wp/v2/location/";
        let location = [];
        fetch(api_url)
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            data.forEach((key, index) => {
                location[index] = key.acf;
            });

        })
        .catch(function (err) {
            console.warn("Error.", err);
        });

        setTimeout(() => {
            this.location = location;
            this.showMap(this.type);
        }, 1000);
    }

    showMap(type, location)
    {
        var this$1 = this;

        var tps_map_styles = [
        {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
            {
                "saturation": "-100",
            },
            ],
        },
        {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [
            {
                "visibility": "off",
            },
            ],
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
            {
                "saturation": -100,
            },
            {
                "lightness": 65,
            },
            {
                "visibility": "on",
            },
            ],
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
            {
                "saturation": -100,
            },
            {
                "lightness": "50",
            },
            {
                "visibility": "simplified",
            },
            ],
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
            {
                "saturation": "-100",
            },
            ],
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
            {
                "visibility": "simplified",
            },
            ],
        },
        {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
            {
                "lightness": "30",
            },
            ],
        },
        {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
            {
                "lightness": "40",
            },
            ],
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
            {
                "saturation": -100,
            },
            {
                "visibility": "simplified",
            },
            ],
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
            {
                "hue": "#ffff00",
            },
            {
                "lightness": -25,
            },
            {
                "saturation": -97,
            },
            ],
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
            {
                "lightness": -25,
            },
            {
                "saturation": -100,
            },
            ],
        },
        ]

        const brand_position = new google.maps.LatLng(this.brand_lat, this.brand_lng);
        const myOptions = {
            zoom: this.zoom,
            center: brand_position,
            mapTypeId: google.maps.MapTypeId.hybrid,
            disableDefaultUI: true,
            zoomControl: true,
            scrollwheel: true,
            disableDoubleClickZoom: true,
            styles: tps_map_styles,
        };
        const map = new google.maps.Map(document.getElementById('contact-map'), myOptions);
        let infoWindows = [];

        setTimeout(() => {

            this.location.forEach((key, index) => {
                let draftMarker = key;
                if (key['address-street'] == location) {
                    let pin = (void 0);
                    let address = (void 0);
                    let myLatLng = new google.maps.LatLng(draftMarker['map-lat'], draftMarker['map-long']);
                    let title = '';

                    if (draftMarker.salon['salon-hours'] !== '' && draftMarker.service['service-hours'] !== '') {
                        pin = {
                            url: this$1.images + 'salon_wrench.png',
                            scaledSize: new google.maps.Size(67, 33),
                            anchor: new google.maps.Point(0, 0),
                        };
                        address = draftMarker['address-street']
                    } else {
                        if (draftMarker.salon['salon-hours'] !== '') {
                              pin = {
                                    url: this$1.images + 'salon.png',
                                    scaledSize: new google.maps.Size(33, 33),
                                    anchor: new google.maps.Point(0, 0),
                            };
                              address = draftMarker['address-street']
                        }

                        if (draftMarker.service['service-hours'] !== '') {
                              pin = {
                                    url: this$1.images + 'wrench.png',
                                    scaledSize: new google.maps.Size(33, 33),
                                    anchor: new google.maps.Point(0, 0),
                            };
                            address = draftMarker['address-street']
                        }
                    }


                    title = draftMarker.name;
                    console.log(draftMarker.salon['salon-hours'])
                    let contentBase = '<h4 class="text-lg"><strong>' + title + '</strong></h4><p class="mb-4">' + draftMarker['address-street'] + ', ' + draftMarker['address-city'] + '</p>';
                    let telSalon = '';
                    let telService = '';
                    if (draftMarker.salon['salon-tel']) {
                        telSalon = '<a class="block mb-4 mt-1 hover:text-primary transition-colors" href="tel:' + draftMarker.salon['salon-tel'] + '">t.: ' + draftMarker.salon['salon-tel'] + '</a>' +
                          '<button class="text-xs button otworz-formularz mb-4 w-auto" data-open-contact-form data-form-name="Salon" data-cf7-id="' + draftMarker.salon['salon-form'] + '" data-cf7-title="Salon">Kontakt z salonem' + '</button>';
                    }
                    if (draftMarker.service['service-tel']) {
                              telService = '<a class="block mb-4 mt-1 hover:text-primary transition-colors" href="tel:' + draftMarker.service['service-tel'] + '">t.: ' + draftMarker.service['service-tel'] + '</a>' +
                                '<button class="text-xs button otworz-formularz mb-2 w-auto" data-open-contact-form data-form-name="Salon" data-cf7-id="' + draftMarker.service['service-form'] + '" data-cf7-title="Serwis">Kontakt z serwisem\n' + '</button>';
                    }
                    let content = '<div class="map-info-box-service font-normal overflow-hidden transition-all opacity-100 sm:opacity-100 sm:max-h-full"><div class="mt-4">' + contentBase +
                    draftMarker.salon['salon-hours'] + telSalon + draftMarker.service['service-hours'] + telService +
                    '</div></div>';

                    let infowindow = new google.maps.InfoWindow({
                        content: content,
                    });


                    let Ignoremarker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        title: title,
                            class: 'marker',
                        icon: pin,
                        address: address,
                    });

                    if (infowindow) {
                            infowindow.close();
                    }

                    infowindow.open(map, Ignoremarker);

                    Ignoremarker.addListener('click', () => {
                          const contactBox = document.querySelectorAll('.map-info-box');
                          contactBox.forEach((box) => {
                                box.style.background = 'white';
                                if (box.getAttribute('data-address') === Ignoremarker.address) {
                                    let numb = box.childNodes.length;
                                    this.slider.slideTo(numb);
                                }

                            });

                    })
                } else if (type === "all") {
                    let pin = (void 0);
                    let address = (void 0);
                    let myLatLng = new google.maps.LatLng(draftMarker['map-lat'], draftMarker['map-long']);
                    let title = '';
                    if (draftMarker.salon['salon-hours'] !== '' && draftMarker.service['service-hours'] !== '') {
                        pin = {
                            url: this$1.images + 'salon_wrench.png',
                            scaledSize: new google.maps.Size(67, 33),
                            anchor: new google.maps.Point(0, 0),
                        };
                        address = draftMarker['address-street']
                    } else {
                        if (draftMarker.salon['salon-hours'] !== '') {
                            pin = {
                                url: this$1.images + 'salon.png',
                                scaledSize: new google.maps.Size(33, 33),
                                anchor: new google.maps.Point(0, 0),
                            };
                            address = draftMarker['address-street']
                        }

                        if (draftMarker.service['service-hours'] !== '') {
                            pin = {
                                url: this$1.images + 'wrench.png',
                                scaledSize: new google.maps.Size(33, 33),
                                anchor: new google.maps.Point(0, 0),
                            };
                            address = draftMarker['address-street']
                        }
                    }

                    title = draftMarker.name;
                    let contentBase = '<h4 class="text-lg"><strong>' + title + '</strong></h4><p class="mb-4">' + draftMarker['address-street'] + ', ' + draftMarker['address-city'] + '</p>';
                    let telSalon = '';
                    let telService = '';
                  if (draftMarker.salon['salon-tel']) {
                    telSalon = '<a class="block mb-4 mt-1 hover:text-primary transition-colors" href="tel:' + draftMarker.salon['salon-tel'] + '">t.: ' + draftMarker.salon['salon-tel'] + '</a>' +
                      '<button class="text-xs button otworz-formularz mb-4 w-auto" data-open-contact-form data-form-name="Salon" data-cf7-id="' + draftMarker.salon['salon-form'] + '" data-cf7-title="Salon">Kontakt z salonem' + '</button>';
                  }
                  if (draftMarker.service['service-tel']) {
                    telService = '<a class="block mb-4 mt-1 hover:text-primary transition-colors" href="tel:' + draftMarker.service['service-tel'] + '">t.: ' + draftMarker.service['service-tel'] + '</a>' +
                      '<button class="text-xs button otworz-formularz mb-2 w-auto" data-open-contact-form data-form-name="Salon" data-cf7-id="' + draftMarker.service['service-form'] + '" data-cf7-title="Serwis">Kontakt z serwisem' + '</button>';
                  }
                  let content = '<div class="map-info-box-service font-normal overflow-hidden transition-all opacity-100 sm:opacity-100 sm:max-h-full"><div class="mt-4">' + contentBase +
                    draftMarker.salon['salon-hours'] + telSalon + draftMarker.service['service-hours'] + telService +
                    '</div></div>';
                    let infowindow = new google.maps.InfoWindow({
                        content: content,
                    });
                    infoWindows.push(infowindow);


                    let Ignoremarker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        title: title,
                        class: 'marker',
                        icon: pin,
                        address: address,
                    });

                    Ignoremarker.addListener('click', () => {

                        for (var i = 0; i < infoWindows.length; i++) {
                            infoWindows[i].close();
                        }


                        infowindow.open(map, Ignoremarker);
                        const contactBox = document.querySelectorAll('.map-info-box');
                        contactBox.forEach((box) => {
                            box.style.background = 'white';
                            if (box.getAttribute('data-address') === Ignoremarker.address) {
                                const swiper = box.parentNode;
                                const parent = swiper.parentNode;
                                const children = Array.from(parent.children);
                                const index = children.indexOf(swiper);
                                this.slider.slideTo(index);
                            }

                        });

                    })
                }

            });

        }, 1300);
    }


}
